var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var fetch = require('node-fetch');

var pageResults = require('graph-results-pager');

var _require = require('./../constants'),
    multicallAddresses = _require.multicallAddresses,
    graphAPIEndpoints = _require.graphAPIEndpoints,
    tokenLists = _require.tokenLists,
    rpcEndpoints = _require.rpcEndpoints,
    nativeCurrency = _require.nativeCurrency,
    tokenAddresses = _require.tokenAddresses,
    supportedNetworks = _require.supportedNetworks;

var Multicall = require('@makerdao/multicall');

var _tokens = {};
var _tokensById = {};
module.exports = {
  fetchTokenPrice: function fetchTokenPrice(addresses, chainId) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var network, addressString, url, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              network = supportedNetworks[chainId];
              addressString = '';
              addresses.forEach(function (address, idx, array) {
                addressString += address;

                if (idx !== array.length - 1) {
                  addressString += ',';
                }
              });
              url = 'https://api.coingecko.com/api/v3/simple/token_price/' + network + '?contract_addresses=' + addressString + '&vs_currencies=usd';
              _context.next = 6;
              return fetch(url, {
                methods: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function (response) {
                return response.json();
              });

            case 6:
              data = _context.sent;
              return _context.abrupt("return", data);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // fetches the token list
  tokens: function tokens(chainId) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var promises, _i, _Object$entries, _Object$entries$_i, value, results;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!chainId) {
                chainId = 100;
              }

              if (!(_tokens[chainId] && _tokens[chainId].length > 0)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", _tokens[chainId]);

            case 5:
              _tokens[chainId] = [];

            case 6:
              promises = [];
              _i = 0, _Object$entries = Object.entries(tokenLists);

            case 8:
              if (!(_i < _Object$entries.length)) {
                _context2.next = 15;
                break;
              }

              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), value = _Object$entries$_i[1];
              _context2.next = 12;
              return promises.push(fetch(value, {
                methods: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function (response) {
                return response.json();
              }));

            case 12:
              _i++;
              _context2.next = 8;
              break;

            case 15:
              if (!_tokensById[chainId]) {
                _tokensById[chainId] = [];
              } // module.exports.tokensById(chainId) //init


              _context2.next = 18;
              return Promise.all(promises);

            case 18:
              results = _context2.sent;
              results.forEach(function (result) {
                if (!result.tokens || result.tokens.length <= 0) return;
                result.tokens.forEach(function (token) {
                  if (Number(token.chainId) !== Number(chainId)) return;
                  if (_tokensById[chainId][token.address.toLowerCase()]) return;
                  _tokensById[chainId][token.address.toLowerCase()] = token;

                  _tokens[chainId].push(token);
                });
              });
              return _context2.abrupt("return", _tokens[chainId]);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  tokensById: function tokensById(chainId) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_tokensById[chainId] && _tokensById[chainId].length > 0)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", _tokensById[chainId]);

            case 4:
              _context3.next = 6;
              return module.exports.tokens(chainId);

            case 6:
              return _context3.abrupt("return", _tokensById[chainId]);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  nativeCurrencyDollarValue: function nativeCurrencyDollarValue(chainId) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return module.exports.tokensPrices({
                tokens: [tokenAddresses[chainId].usdc],
                chain_id: chainId
              });

            case 3:
              data = _context4.sent;
              _context4.next = 9;
              break;

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              console.log('tulip-backend', _context4.t0);

            case 9:
              if (!(data && data[0] && data[0].derivedNativeCurrency)) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", 1 / Number(data[0].derivedNativeCurrency));

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 6]]);
    }))();
  },
  // gets a list of all non zero token balances in an wallet address
  tokenBalances: function tokenBalances() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _ref, _ref$user_address, user_address, _ref$chain_id, chain_id, tokens, multicallQuery, config, nonzeroBalances, gqlIdQuery, properties, tokenData, tokensById, nativeCurrencyDollarPrice, results;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$user_address = _ref.user_address, user_address = _ref$user_address === void 0 ? undefined : _ref$user_address, _ref$chain_id = _ref.chain_id, chain_id = _ref$chain_id === void 0 ? '100' : _ref$chain_id;

              if (user_address) {
                _context5.next = 3;
                break;
              }

              throw new Error('tulip-data: User address undefined');

            case 3:
              _context5.next = 5;
              return module.exports.tokens(chain_id);

            case 5:
              tokens = _context5.sent;
              multicallQuery = [];
              tokens.forEach(function (token) {
                multicallQuery.push({
                  target: token.address,
                  call: ['balanceOf(address)(uint256)', user_address],
                  returns: [[token.address, function (val) {
                    return val / Math.pow(10, token.decimals);
                  }]]
                });
              }); // fetch nativeCurrency balance

              multicallQuery.push({
                call: ['getEthBalance(address)(uint256)', user_address],
                returns: [['native_currency', function (val) {
                  return val / Math.pow(10, 18);
                }]]
              });
              config = {
                rpcUrl: rpcEndpoints[chain_id],
                multicallAddress: multicallAddresses[chain_id]
              };
              nonzeroBalances = {};
              gqlIdQuery = '';
              _context5.prev = 12;
              _context5.next = 15;
              return Multicall.aggregate(multicallQuery, config).then(function (resultObject) {
                var gqlIds = [];
                Object.entries(resultObject.results.transformed).forEach(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      key = _ref3[0],
                      value = _ref3[1];

                  if (value !== 0) {
                    nonzeroBalances[key.toLowerCase()] = value;
                    gqlIds.push('\\"' + key.toLowerCase() + '\\"');
                  }
                });
                gqlIdQuery = '[' + gqlIds.join(',') + ']';
              });

            case 15:
              _context5.next = 21;
              break;

            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](12);
              console.error(_context5.t0);
              return _context5.abrupt("return");

            case 21:
              // get data from honeyswap
              properties = ['id', 'symbol', 'derivedNativeCurrency'];
              _context5.next = 24;
              return pageResults({
                api: graphAPIEndpoints[chain_id].honeyswap,
                query: {
                  entity: 'tokens',
                  selection: {
                    where: {
                      id_in: gqlIdQuery
                    }
                  },
                  properties: properties
                }
              }).then(function (results) {
                return results;
              }).catch(function (err) {
                return console.log('graph error', err);
              });

            case 24:
              tokenData = _context5.sent;
              tokensById = {};
              tokens.forEach(function (entry) {
                tokensById[entry.address.toLowerCase()] = _objectSpread({
                  address: entry.address.toLowerCase()
                }, entry);
              });
              _context5.next = 29;
              return module.exports.nativeCurrencyDollarValue(chain_id);

            case 29:
              nativeCurrencyDollarPrice = _context5.sent;
              results = [];
              tokenData.forEach(function (token) {
                var balance = Number(nonzeroBalances[token.id]);

                var result = _objectSpread(_objectSpread({}, tokensById[token.id]), {}, {
                  balance: balance.valueOf(),
                  priceUSD: Number(token.derivedNativeCurrency) * Number(nativeCurrencyDollarPrice),
                  valueUSD: Number(token.derivedNativeCurrency * nonzeroBalances[token.id]) * Number(nativeCurrencyDollarPrice)
                });

                results.push(result);
              }); // add the user wallet native currency balance

              if (nonzeroBalances.native_currency) {
                results.push({
                  balance: nonzeroBalances.native_currency.valueOf(),
                  priceUSD: nativeCurrencyDollarPrice,
                  valueUSD: nonzeroBalances.native_currency * nativeCurrencyDollarPrice,
                  name: nativeCurrency[chain_id].name,
                  symbol: nativeCurrency[chain_id].symbol,
                  logoURI: tokensById[nativeCurrency[chain_id].wrappedAddress].logoURI // wxdai logo

                });
              }

              return _context5.abrupt("return", _tokenBalances.callback(results));

            case 34:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[12, 17]]);
    }))();
  },
  // TODO: add more exchanges/only works with honeyswap subgraph and tokenlist for now
  poolBalances: function poolBalances() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _ref4, _ref4$user_address, user_address, _ref4$chain_id, chain_id, properties, poolData, pairData;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _ref4 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref4$user_address = _ref4.user_address, user_address = _ref4$user_address === void 0 ? undefined : _ref4$user_address, _ref4$chain_id = _ref4.chain_id, chain_id = _ref4$chain_id === void 0 ? '100' : _ref4$chain_id;

              if (user_address) {
                _context6.next = 3;
                break;
              }

              throw new Error('tulip-data: User address undefined');

            case 3:
              properties = ['id', 'liquidityPositions { liquidityTokenBalance, pair { id, token0 { id, symbol, name, derivedNativeCurrency }, token1 { id, symbol, name, derivedNativeCurrency }, reserve0, reserve1, reserveUSD, totalSupply} }'];
              _context6.next = 6;
              return pageResults({
                api: graphAPIEndpoints[chain_id].honeyswap,
                query: {
                  entity: 'users',
                  selection: {
                    where: {
                      id: "\\\"".concat(user_address.toLowerCase(), "\\\"")
                    }
                  },
                  properties: properties
                }
              }).then(function (results) {
                return results;
              }).catch(function (err) {
                return console.log(err);
              });

            case 6:
              poolData = _context6.sent;

              if (!(poolData && poolData[0] && poolData[0].liquidityPositions)) {
                _context6.next = 12;
                break;
              }

              _context6.next = 10;
              return module.exports.pairData(poolData[0].liquidityPositions, 'Honeyswap', chain_id);

            case 10:
              pairData = _context6.sent;
              return _context6.abrupt("return", _poolBalances.callback(pairData));

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  stakedBalances: function stakedBalances() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var _ref5, _ref5$user_address, user_address, _ref5$chain_id, chain_id, farm, deposits, pairIds, liquidityPositions, liquidityPositionsById, pairsPrices, pairData;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _ref5 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, _ref5$user_address = _ref5.user_address, user_address = _ref5$user_address === void 0 ? undefined : _ref5$user_address, _ref5$chain_id = _ref5.chain_id, chain_id = _ref5$chain_id === void 0 ? '100' : _ref5$chain_id;
              farm = require('./farm');
              _context7.next = 4;
              return farm.deposits({
                user_address: user_address,
                chain_id: chain_id
              });

            case 4:
              deposits = _context7.sent;
              pairIds = [];
              liquidityPositions = [];
              liquidityPositionsById = {};
              deposits.forEach(function (deposit) {
                pairIds.push(deposit.pool);
                var position = {
                  liquidityTokenBalance: deposit.amount,
                  address: deposit.pool.toLowerCase(),
                  pair: undefined
                };

                if (!liquidityPositionsById[deposit.pool.toLowerCase()]) {
                  liquidityPositionsById[deposit.pool.toLowerCase()] = [];
                }

                liquidityPositionsById[deposit.pool.toLowerCase()].push(position);
              });
              _context7.next = 11;
              return module.exports.pairsPrices({
                pairs: pairIds,
                chain_id: chain_id
              });

            case 11:
              pairsPrices = _context7.sent;
              pairsPrices.forEach(function (pair) {
                var positions = liquidityPositionsById[pair.id.toLowerCase()];
                positions.forEach(function (position) {
                  position.pair = pair;
                  liquidityPositions.push(position);
                });
              });
              _context7.next = 15;
              return module.exports.pairData(liquidityPositions, 'Tulip', chain_id);

            case 15:
              pairData = _context7.sent;
              return _context7.abrupt("return", _poolBalances.callback(pairData));

            case 17:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  simplyTokenBalances: function simplyTokenBalances() {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _ref6, _ref6$user_address, user_address, _ref6$chain_id, chain_id, _ref6$tokens, tokens, _ref6$web, web3, multicallQuery, config;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref6 = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {}, _ref6$user_address = _ref6.user_address, user_address = _ref6$user_address === void 0 ? undefined : _ref6$user_address, _ref6$chain_id = _ref6.chain_id, chain_id = _ref6$chain_id === void 0 ? '100' : _ref6$chain_id, _ref6$tokens = _ref6.tokens, tokens = _ref6$tokens === void 0 ? undefined : _ref6$tokens, _ref6$web = _ref6.web3, web3 = _ref6$web === void 0 ? undefined : _ref6$web;

              if (user_address) {
                _context8.next = 3;
                break;
              }

              throw new Error('tulip-data: User address undefined');

            case 3:
              multicallQuery = [];
              tokens.forEach(function (token) {
                multicallQuery.push({
                  target: token,
                  call: ['balanceOf(address)(uint256)', user_address],
                  returns: [[token]]
                });
              });
              config = {
                web3: web3,
                multicallAddress: multicallAddresses[chain_id]
              };
              _context8.prev = 6;
              _context8.next = 9;
              return Multicall.aggregate(multicallQuery, config).then(function (result) {
                return result.results.transformed;
              });

            case 9:
              return _context8.abrupt("return", _context8.sent);

            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8["catch"](6);
              console.error(_context8.t0);
              return _context8.abrupt("return", []);

            case 16:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[6, 12]]);
    }))();
  },
  pairData: function pairData(positions, platform, chainId) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var tokensById, tokens, nativeCurrencyDollarValue, results;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              tokensById = [];
              _context9.next = 3;
              return module.exports.tokens(chainId);

            case 3:
              tokens = _context9.sent;
              tokens.forEach(function (token) {
                tokensById[token.address.toLowerCase()] = token;
              });
              _context9.next = 7;
              return module.exports.nativeCurrencyDollarValue(chainId);

            case 7:
              nativeCurrencyDollarValue = _context9.sent;
              results = [];
              positions.forEach(function (position) {
                var token0 = Object.assign({}, tokensById[position.pair.token0.id]);

                if (!token0) {
                  token0 = {
                    name: position.pair.token0.name,
                    symbol: position.pair.token0.symbol,
                    address: position.pair.token0.id,
                    logoURI: null
                  };
                }

                var token1 = Object.assign({}, tokensById[position.pair.token1.id]);

                if (!token1) {
                  token1 = {
                    name: position.pair.token1.name,
                    symbol: position.pair.token1.symbol,
                    address: position.pair.token1.id,
                    logoURI: null
                  };
                }
                /*
                get liquidity value of single token
                 getLiquidityValue()
                from: https://github.com/Uniswap/uniswap-v2-sdk/blob/main/src/entities/pair.ts
                JSBI.divide(JSBI.multiply(liquidity.raw, this.reserveOf(token).raw), totalSupplyAdjusted.raw)
                 let liquidityValueUSD = position.liquidityTokenBalance * position.pair.reserve0 / position.pair.totalSupply;
                liquidityValueUSD = liquidityValueUSD * position.pair.token0.derivedNativeCurrency * 2;
                */


                token0.balance = position.liquidityTokenBalance * position.pair.reserve0 / position.pair.totalSupply;
                token1.balance = position.liquidityTokenBalance * position.pair.reserve1 / position.pair.totalSupply; // in this case eth == dai == usd

                token0.priceUSD = position.pair.token0.derivedNativeCurrency * nativeCurrencyDollarValue;
                token1.priceUSD = position.pair.token1.derivedNativeCurrency * nativeCurrencyDollarValue;
                token0.valueUSD = token0.balance * position.pair.token0.derivedNativeCurrency * nativeCurrencyDollarValue;
                token1.valueUSD = token1.balance * position.pair.token1.derivedNativeCurrency * nativeCurrencyDollarValue;
                /* get usd value of owned pool tokens */

                var liquidityValueUSD = position.pair.reserveUSD / position.pair.totalSupply * position.liquidityTokenBalance;
                if (position.liquidityTokenBalance <= 0) return;
                results.push({
                  tokens: [token0, token1],
                  address: position.pair.id,
                  balance: position.liquidityTokenBalance,
                  valueUSD: liquidityValueUSD,
                  platform: platform
                });
              });
              return _context9.abrupt("return", results);

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  pairsPrices: function pairsPrices() {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var _ref7, _ref7$pairs, pairs, _ref7$chain_id, chain_id, gqlIds, gqlIdQuery, properties, pairsData, tokensById;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _ref7 = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {}, _ref7$pairs = _ref7.pairs, pairs = _ref7$pairs === void 0 ? undefined : _ref7$pairs, _ref7$chain_id = _ref7.chain_id, chain_id = _ref7$chain_id === void 0 ? '100' : _ref7$chain_id;
              gqlIds = [];
              pairs.forEach(function (pair) {
                gqlIds.push('\\"' + pair.toLowerCase() + '\\"');
              });
              gqlIdQuery = '[' + gqlIds.join(',') + ']';
              properties = ['id', 'token0 { id, symbol, name, derivedNativeCurrency }', 'token1 { id, symbol, name, derivedNativeCurrency }', 'reserve0', 'reserve1', 'reserveUSD', 'totalSupply'];
              _context10.next = 7;
              return pageResults({
                api: graphAPIEndpoints[chain_id].honeyswap,
                query: {
                  entity: 'pairs',
                  selection: {
                    where: {
                      id_in: gqlIdQuery
                    }
                  },
                  properties: properties
                }
              }).then(function (results) {
                return results;
              }).catch(function (err) {
                return console.log(err);
              });

            case 7:
              pairsData = _context10.sent;
              _context10.next = 10;
              return module.exports.tokensById(chain_id);

            case 10:
              tokensById = _context10.sent;
              pairsData.forEach(function (pair) {
                var i = 0;

                do {
                  var token = tokensById[pair['token' + i].id.toLowerCase()];
                  var logoURI = null;

                  if (token) {
                    logoURI = token.logoURI;
                  }

                  pair['token' + i].logoURI = logoURI;
                  i++;
                } while (pair['token' + i] !== undefined);
              });
              return _context10.abrupt("return", pairsData);

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },
  tokensPrices: function tokensPrices() {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var _ref8, _ref8$tokens, tokens, _ref8$chain_id, chain_id, gqlIds, gqlIdQuery, properties, data;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _ref8 = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {}, _ref8$tokens = _ref8.tokens, tokens = _ref8$tokens === void 0 ? undefined : _ref8$tokens, _ref8$chain_id = _ref8.chain_id, chain_id = _ref8$chain_id === void 0 ? '100' : _ref8$chain_id;
              gqlIds = [];
              tokens.forEach(function (token) {
                gqlIds.push('\\"' + token.toLowerCase() + '\\"');
              });
              gqlIdQuery = '[' + gqlIds.join(',') + ']';
              properties = ['id', 'symbol', 'derivedNativeCurrency'];
              _context11.next = 7;
              return pageResults({
                api: graphAPIEndpoints[chain_id].honeyswap,
                query: {
                  entity: 'tokens',
                  selection: {
                    where: {
                      id_in: gqlIdQuery
                    }
                  },
                  properties: properties
                }
              }).then(function (results) {
                return results;
              }).catch(function (err) {
                return console.log(err);
              });

            case 7:
              data = _context11.sent;
              return _context11.abrupt("return", data);

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  }
};
var tokenBalance = {
  callback: function callback(entry) {
    return {
      balance: Number(entry.balance),
      name: entry.name,
      address: entry.address,
      symbol: entry.symbol,
      logoURI: entry.logoURI,
      priceUSD: Number(entry.priceUSD),
      valueUSD: Number(entry.valueUSD)
    };
  }
};
var _tokenBalances = {
  callback: function callback(results) {
    return results.map(function (entry) {
      return tokenBalance.callback(entry);
    });
  }
};
var _poolBalances = {
  callback: function callback(results) {
    results.map(function (entry) {
      var result = {
        balance: Number(entry.balance),
        valueUSD: Number(entry.valueUSD),
        address: entry.address,
        poolPlatform: entry.poolPlatform ? entry.poolPlatform : undefined,
        stakePlatform: entry.stakePlatform ? entry.stakePlatform : undefined,
        status: entry.status ? entry.status : undefined
      };
      result.tokens = entry.tokens.map(function (token) {
        return tokenBalance.callback(token);
      });
    });
    return results;
  }
};